var Preloader = function () {
    var $element = null;
    var sources = [];

    this.show = function (source) {
        $element.show().focus();
        sources.push(source);
    };
    this.hide = function (source) {
        var source_index = sources.indexOf(source);
        sources.splice(source_index, 1);

        if (sources.length == 0) {
            $element.hide();
        }
    };

    this.init = function () {
        $element = $('.bulk-po #loadingWait');
    };
};

module.exports = new Preloader();


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/components/preloader.js
// module id = 3
// module chunks = 0